var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.751,
    height: 18.51,
    viewBox: "0 0 21.751 18.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Viajes",
    transform: "translate(-2 -5.326)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_332",
    "data-name": "Elipse 332",
    cx: 0.862,
    cy: 0.862,
    r: 0.862,
    transform: "translate(2 17.629)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7691",
    "data-name": "Trazado 7691",
    d: "M8.677,14.994l-.37.185A.614.614,0,0,0,8.03,16L9.9,19.749a.613.613,0,0,1,.059.361l-.1.673a.614.614,0,0,0,.608.7h0a.613.613,0,0,0,.34-.1l1.031-.687a.616.616,0,0,1,.34-.1h.541a.614.614,0,0,0,.614-.614v-.113a.614.614,0,0,1,.614-.614h3.152a.612.612,0,0,1,.434.18L18.7,20.591v.448h.862a.614.614,0,0,1,.6.465l.214,1.3a.614.614,0,0,0,.592.463H21.9a.614.614,0,0,0,.549-.339l.107-.215a.614.614,0,0,1,.549-.339h.6c.22,0,.423-.565.533-.756L25.8,18.89a.607.607,0,0,0,.069-.184l.382-1.91a.615.615,0,0,0-.069-.425l-1.556-2.722a.613.613,0,0,0-.339-.276l-.745-.248a.614.614,0,0,1-.416-.515l-.143-1.288a.614.614,0,0,0-.336-.481l-.256-.128a.614.614,0,0,1-.339-.549V9.2H21.6l-1.048,1.746a.614.614,0,0,1-.8.233l-.8-.4a.614.614,0,0,1-.308-.743l.009-.028a.614.614,0,0,0-.582-.808H16.625a.614.614,0,0,0-.549.339l-.5,1.007a.614.614,0,0,1-.7.321l-.9-.226a.614.614,0,0,0-.648.239l-1.9,2.663a.611.611,0,0,1-.225.192l-1,.5",
    transform: "translate(-3.909 -2.538)",
    fill: "#ffce56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_333",
    "data-name": "Elipse 333",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(11.302 11.889)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_221",
    "data-name": "L\\xEDnea 221",
    y2: 0.69,
    transform: "translate(12.001 20.732)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_222",
    "data-name": "L\\xEDnea 222",
    y2: 0.69,
    transform: "translate(12.001 22.802)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_223",
    "data-name": "L\\xEDnea 223",
    x2: 0.69,
    transform: "translate(10.622 22.112)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_224",
    "data-name": "L\\xEDnea 224",
    x2: 0.69,
    transform: "translate(12.691 22.112)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7692",
    "data-name": "Trazado 7692",
    d: "M44.653,54h1.31a.233.233,0,0,1,.209.338l-.519,1.386-1.21-1.386a.233.233,0,0,1,.21-.338Z",
    transform: "translate(-27.79 -31.888)",
    fill: "#ffce56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7693",
    "data-name": "Trazado 7693",
    d: "M10.705,5.326A2.705,2.705,0,0,0,8.034,8.063c0,1.512,2.672,5.083,2.672,5.083s2.672-3.571,2.672-5.083a2.7,2.7,0,0,0-2.672-2.737Zm0,4.122a1.386,1.386,0,1,1,1.352-1.385A1.369,1.369,0,0,1,10.705,9.448Z",
    transform: "translate(-3.953)",
    fill: "#f96e43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7694",
    "data-name": "Trazado 7694",
    d: "M42.705,22.326a2.705,2.705,0,0,0-2.672,2.737c0,1.512,2.672,5.083,2.672,5.083s2.672-3.571,2.672-5.083A2.7,2.7,0,0,0,42.705,22.326Zm0,4.122a1.386,1.386,0,1,1,1.352-1.385A1.369,1.369,0,0,1,42.705,26.448Z",
    transform: "translate(-21.626 -15.137)",
    fill: "#f96e43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7695",
    "data-name": "Trazado 7695",
    d: "M42.705,22.326a2.705,2.705,0,0,0-2.672,2.737c0,1.512,2.672,5.083,2.672,5.083s2.672-3.571,2.672-5.083A2.7,2.7,0,0,0,42.705,22.326Zm0,4.122a1.386,1.386,0,1,1,1.352-1.385A1.369,1.369,0,0,1,42.705,26.448Z",
    transform: "translate(-29.067 -10.792)",
    fill: "#f96e43"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrips);
export default __webpack_public_path__ + "static/media/trips.98aff1344d76bb772fbff4a1d58b4c79.svg";
export { ForwardRef as ReactComponent };